<div>
    <div class="mb-8 fx-row align-items-center justify-content-between" *ngIf="title">
        <span class="text light">{{'ENTITIES.TAGS' | translate}}</span>
        <mat-icon class="green clickable" matRipple roleBasedElement [roles]="['SUPERADMIN','ADMIN','MANAGER']"
            fontSet="material-icons-outlined" (click)="addTags()">add_circle</mat-icon>
    </div>
    <div class="fx-row fx-wrap align-items-center justify-content-between mb-10">
        <div class="fx-row fx-flex-100 border-box align-items-center justify-content-between mb-10"
            *ngFor="let tag of tags | sort:'confidence':'desc' | limit:limit; let index = index">
            <div class="fx-row fx-flex-100 align-items-center justify-content-between">
                <div class="chip main">
                    {{tag.label}}
                </div>
                <mat-icon class="red clickable" roleBasedElement [roles]="['SUPERADMIN','ADMIN','MANAGER']"
                    fontSet="material-icons-outlined" (click)="deleteTag(tag)" matRipple>delete</mat-icon>
            </div>
        </div>
    </div>
    <span class="text" *ngIf="!tags || tags.length === 0">{{'DOCUMENT.NO_TAGS' | translate}}</span>
    <div class="fx-row w-100 align-items-center justify-content-end mt-10 clickable" *ngIf="tags.length > 3">
        <span class="text main " (click)="toggle()">{{(limit === 3 ? 'UTILS.SEE_MORE' : 'UTILS.SEE_LESS') |
            translate}}</span>
        <mat-icon class="main ml-5" fontSet="material-icons-outlined">{{limit === 3 ? 'keyboard_arrow_down' :
            'keyboard_arrow_up'}}</mat-icon>
    </div>
</div>